import { GeneralSettings, GeneralSettingsDef } from "@mcleod/core";

export interface LMEGeneralSettingsDef extends GeneralSettingsDef {
    dispatch_control: any;
    ar_control: any;
    payroll_control: any;
    detention_control: any;
    seg_alloc_control: any;
    excisetax_control: any;
    pbw_support_email_address?: string;
    agent_access_control: any;
    amqp?: string;
}

export class LMEGeneralSettings extends GeneralSettings {
    public static getSingleton(): LMEGeneralSettings {
        return GeneralSettings.getSingleton() as LMEGeneralSettings;
    }

    public static get(): LMEGeneralSettingsDef {
        return LMEGeneralSettings.getSingleton().values as LMEGeneralSettingsDef;
    }

    public override get values(): LMEGeneralSettingsDef {
        return super.values as LMEGeneralSettingsDef;
    }

    protected getValuesInternal(): LMEGeneralSettingsDef {
        return this._values as LMEGeneralSettingsDef;
    }

    override _doAfterSet(newValues: any, isAuthSet: boolean) {
        const values = this._values as LMEGeneralSettingsDef;
        values.messaging_passcode = values.amqp;
        super._doAfterSet(newValues, isAuthSet);
        delete values.amqp;
    }

    public getDispatchControl(): any {
        return { ...this.getValuesInternal()?.dispatch_control[0] };
    }

    public getARControl(): any {
        return { ...this.getValuesInternal()?.ar_control[0] };
    }

    public getPayrollControl(): any {
        return { ...this.getValuesInternal()?.payroll_control[0] };
    }

    public getDetentionControl(): any {
        return { ...this.getValuesInternal()?.detention_control[0] };
    }

    public getSegAllocControl(): any {
        return { ...this.getValuesInternal()?.seg_alloc_control[0] };
    }

    public getExciseTaxControl(): any {
        return { ...this.getValuesInternal()?.excisetax_control[0] };
    }

    public getAgentAccessControl(): any {
        return { ...this.getValuesInternal()?.agent_access_control[0] };
    }
}
